export let CloudinaryMediaTransformationBuilder = /*#__PURE__*/(() => {
  class CloudinaryMediaTransformationBuilder {
    // some transformations are CHAINED, for example rotation. 
    // These would not work with current version of the transformation builder.
    static {
      this.dictionary = {
        ratio: 'ar',
        resize: 'c',
        gravity: 'g',
        height: 'h',
        quality: 'q',
        width: 'w'
      };
    }
    static applyDefaults(t) {
      // apply default values if not set.
      if (t.width || t.height || t.ratio) {
        // 2022-05 has to be disabled because it was not implemented correctly before.
        // when triggering eager transformations, the resize parameter should have been mapped to "crop" parameter.
        // this didn't happen so generated transformations never had the c_scale parameter in them.
        // with the update implemented in 2022-05, the c_scale parameter would be part of generated URLs.
        // these URLs are incorrect because no transformation with c_scale was actually executed.
        // as the parameter doesnt change anything due to all videos being exactly 16:9, the parameter could be disabled.
        // if(!t.resize) t.resize = 'scale';
      }
      if (t.width && t.height || t.ratio) {
        if (!t.focus) t.focus = 'auto';
        if (!t.resize) t.resize = 'fill';
      }
      if (!t.quality) t.quality = 70;
      return t;
    }
    static toURL(t) {
      return this.toUrlString(t);
    }
    static toUrlString(transformations, mergeDefaultValues = true) {
      // map object based transformations into compressed URL version 
      // e.g. {width:100,quality:70} to q_70,w_100
      if (mergeDefaultValues) transformations = this.applyDefaults(transformations);
      const urlParametersMap = this.mediaTransformationToUrlParams(transformations);
      // cloudinary sorts URL parameters alphabetically.
      // transformation info must always be passed in correct order, otherwise cloudinary would not find pre-transformed items.
      // to be able to sort correctly, map the parameters into a temporary object, sort it and then build a string out of it.
      // https://support.cloudinary.com/hc/en-us/requests/107569?page=1
      // cloudinary API url builder: 
      // https://github.com/cloudinary/cloudinary_npm/blob/307da73d25716e36c2083e5b26908c24f8fcb72d/lib/utils/index.js#L452
      urlParametersMap.sort((paramA, paramB) => {
        if (paramA.name < paramB.name) return -1;else if (paramA.name > paramB.name) return 1;else return 0;
      });
      return urlParametersMap.map(val => {
        return val.name + '_' + val.value;
      }).join(',');
    }
    static mediaTransformationToUrlParams(transformations) {
      const urlParametersMap = [];
      for (const k in transformations) {
        if (this.dictionary[k]) {
          let value = transformations[k];
          const name = this.dictionary[k];
          if (k === 'quality') {
            // in case passed quality is a string, convert it to one of cloudinaries "auto" modes
            value = 'auto:' + value;
          }
          urlParametersMap.push({
            name,
            value
          });
        }
      }
      return urlParametersMap;
    }
    static toCloudinaryTransformation(mediaTransformation) {
      function focusToGravity(focus) {
        if (!focus) return undefined;
        switch (focus) {
          case 'auto':
            return 'center';
          case 'center':
            return 'center';
          case 'left':
            return 'west';
          case 'right':
            return 'east';
          case 'bottom':
            return 'south';
          case 'top':
            return 'north';
          case 'topleft':
            return 'north_west';
          case 'topright':
            return 'north_east';
          case 'bottomleft':
            return 'south_west';
          case 'bottomright':
            return 'south_east';
        }
      }
      // #86c2dvmcm - according to CL support, quality presets like good, eco must be prefixed with "auto:".
      // https://support.cloudinary.com/hc/requests/311898
      const quality = typeof mediaTransformation.quality === 'number' ? mediaTransformation.quality : 'auto:' + mediaTransformation.quality;
      const out = {
        width: mediaTransformation.width,
        // NOTE: required for videos!
        height: mediaTransformation.height,
        resize: mediaTransformation.resize,
        // TODO: cloudinary uses keyword CROP. Need to update API to use correct keyword.
        ratio: mediaTransformation.ratio,
        // e.g. "4:3"
        gravity: focusToGravity(mediaTransformation.focus),
        // center, east, north_east etc
        quality
      };
      return out;
    }
  }
  return CloudinaryMediaTransformationBuilder;
})();